enum ContextualMenuItemType {
	SetAsTemplate = 'SetAsTemplate',
	RemoveTemplate = 'RemoveTemplate',
	Download = 'Download',
	Delete = 'Delete',
	Update = 'Update',
	Share = 'Share',
	Edit = 'Edit',
	ProposalSaveAs = 'ProposalSaveAs',
	ProposalNoSaveAs = 'ProposalNoSaveAs',
	Rename = 'Rename',
	DeleteFromAsp = 'DeleteFromAsp',
}

export {
	ContextualMenuItemType,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/constants.ts